import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom"
import MaterialTable from "material-table";
import Sidebar from '../../Template/Sidebar/Sidebar';
import Header from '../../Template/Header/Header';
import {baseUrl} from '../../../config';
import DatePicker from "react-datepicker";
import './takerate.css';
import moment from 'moment'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import "react-datepicker/dist/react-datepicker.css";
import {clickColor,inArray} from '../../../library/util';
import CloseIcon from '@mui/icons-material/Close';
import SummarizeIcon from '@mui/icons-material/Summarize';

import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Loader from 'react-loader-spinner';

import Typography from "@material-ui/core/Typography";
import {formatNumberWithToFixed} from '../ProfitabilityDiagnosis/js/commanFn';


import AsyncSelect from 'react-select/async';
import makeAnimated from 'react-select/animated';
import AddIcon from '@mui/icons-material/Add';
import objAdvancedFilter from '../../../library/advancedFilterLibFn';
import axiosIntance from '../../../helper/axios';

import { checkTakeRateOfferAccess, checkAccess, FEATURES } from '../../../library/auth'

const animatedComponents = makeAnimated();

const colourStyles = {
  menuList: styles => ({
      ...styles,
      background: 'white'
  }),
  option: (styles, {isFocused, isSelected}) => ({
      ...styles,
      background: isFocused
          ? 'lightblue'
          : isSelected
              ? '#2a7bc0'
              : undefined,
      zIndex: 1
  }),
  menu: base => ({
      ...base,
      zIndex: 100
  })
  }
  const style_advanced = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
const AddIconClasses={ color: '#337ab7',fontSize:'30px',marginLeft:'128px',marginTop:"-15px",cursor: 'pointer' };

const style = {
  position: 'absolute',
  
  // left: '50%',
  right:'-22%',
  padding:'3px',
  transform: 'translate(-50%, -0%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  align:'right',
  top: '83px',
  width: '44%',
  height: '100%',
  maxHeight:'550px',
  overflowY: 'auto'
  
};

const styleCloseIcon={
  margin:'-27px'
}


function TakeRate() {
    const history = useHistory();
    const [selectedRow, setSelectedRow] = useState(null);
    const { type } = useParams()
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [summary,setSummary]=useState([]);
    const [showSummaryDiv,setShowSummaryDiv]=useState(false)

    console.log(type);
    let midTitle='';
     console.log(type);
    if (type === 'fulesavepro') {
      midTitle="Fuel Save Pro"
    } else if (type === 'alphaheater') {
      midTitle='Alpha heater';
    } else if (type === 'dermaboltipl') {
      midTitle='Dermabolt IPL';
    } else if (type === 'akemiglow') {
      midTitle='Akemi Glow';
    } else if (type === 'buzzbugwatch') {
      midTitle='Buzz Bugwatch';
    } else if (type === 'byecritter') {
      midTitle='Bye Critter';
    } else if (type === 'cleanjett') {
      midTitle='CleanJett';
    } else if (type === 'eliteTac') {
      midTitle='EliteTac';
    } else if (type === 'extendtecc') {
      midTitle='Extendtecc';
    } else if (type === 'extendteccregular') {
      midTitle='Extendtecc (Regular)';
    } else if (type === 'extendteccrevboost'
            || type === 'extendteccrevboostspecial') {
      midTitle='Extendtecc (Revboost)';
    } else if (type === 'fuzebug') {
      midTitle='Fuzebug';
    } else if (type === 'inductivv') {
      midTitle='Inductivv';
    } else if (type === 'ionpure') {
      midTitle='Ion Pure';
    } else if (type === 'ionpurenormal') {
      midTitle='Ion Pure (Normal)';
    } else if (type === 'ionpurerevboost'
            || type === 'ionpurerevboostspecial') {
      midTitle='Ion Pure (Revboost)';
    } else if (type === 'megamagnaboom') {
      midTitle='Mega MagnaBOOM';
    } else if (type === 'mitefighter') {
      midTitle='Mite Fighter';
    } else if (type === 'nettecboost') {
      midTitle='NetTec Boost';
    } else if (type === 'orthopick') {
      midTitle='Orthopick';
    } else if (type === 'orthosparklede') {
      midTitle='OrthoSparkle DE';
    } else if (type === 'outsmart') {
      midTitle='Outsmart';
    } else if (type === 'pestdefence') {
      midTitle='Pest Defence';
    } else if (type === 'pestdefencede') {
      midTitle='Pest Defence DE';
    } else if (type === 'poppchopp') {
      midTitle='Popp Chopp';
    } else if (type === 'propowersave') {
      midTitle='Pro Power Save';
    } else if (type === 'propowersaveuk') {
      midTitle='Pro Power Save UK';
    } else if (type === 'propowersavede') {
      midTitle='Pro Power Save DE';
    } else if (type === 'recovstick') {
      midTitle='RecovStick US';
    } else if (type === 'recovstickde') {
      midTitle='RecovStick DE';
    } else if (type === 'recovstickdeold') {
      midTitle='RecovStick DE old';
    } else if (type === 'recovstickuk') {
      midTitle='RecovStick UK';
    } else if (type === 'securelitecam') {
      midTitle='Secure Lite Cam';
    } else
    if (type === 'allbrandsDE') {
      midTitle='Heater DE All Brand';
    } else if (type === 'alphaheaterDE') {
      midTitle='Heater DE Alpha Heater'
    } else if (type === 'blissheatereu') {
      midTitle='Heater DE Bliss Heater'
    } else if (type === 'heatloopDE') {
      midTitle='Heater DE Heat Loop'
    } else if (type === 'heatfinitiDE') {
      midTitle='Heater DE Heatfiniti'
    } else if (type === 'novaheateu') {
      midTitle='Heater DE Nova Heat'
    } else if (type === 'onsenheateu') {
      midTitle='Heater DE Onsen Heat'
    } else if (type === 'pyrexheatde') {
      midTitle='Heater DE Pyrex Heat'
    } else if (type === 'smartheatereu') {
      midTitle='Heater DE Smart Heater'
    } else if (type === 'solheaterDE') {
      midTitle='Heater DE Sol Heater'
    } else if (type === 'vidaheatDE') {
      midTitle='Heater DE Vida Heat'
    } else if (type === 'vistaheatDE') {
      midTitle='Heater DE Vista Heat'
    } else if (type === 'vitalheateu') {
      midTitle='Heater DE Vital Heat'
    } else if (type === 'vitalheatproeu') {
      midTitle='Heater V2 DE Vital Heat Pro'
    } else if (type === 'warmwaveheateu') {
      midTitle='Heater V2 DE Warm Wave Heat'
    } else 
    if (type === 'allbrandsUK') {
      midTitle='Heater UK All Brand';
    } else if (type === 'alphaheaterUK') {
      midTitle='Heater UK Alpha Heater'
    } else if (type === 'blissheateruk') {
      midTitle='Heater UK Bliss Heater'
    } else if (type === 'heatloopUK') {
      midTitle='Heater UK Heat Loop'
    } else if (type === 'heatfinitiUK') {
      midTitle='Heater UK Heatfiniti'
    } else if (type === 'novaheatuk') {
      midTitle='Heater UK Nova Heat'
    } else if (type === 'onsenheatuk') {
      midTitle='Heater UK Onsen Heat'
    } else if (type === 'pyrexheatuk') {
      midTitle='Heater UK Pyrex Heat'
    } else if (type === 'smartheateruk') {
      midTitle='Heater UK Smart Heater'
    } else if (type === 'solheaterUK') {
      midTitle='Heater UK Sol Heater'
    } else if (type === 'vidaheatUK') {
      midTitle='Heater UK Vida Heat'
    } else if (type === 'vistaheatUK') {
      midTitle='Heater UK Vista Heat'
    } else if (type === 'vitalheatuk') {
      midTitle='Heater UK Vital Heat'
    } else if (type === 'vitalheatprouk') {
      midTitle='Heater V2 UK Vital Heat Pro'
    } else if (type === 'warmwaveheatuk') {
      midTitle='Heater V2 UK Warm Wave Heat'
    } else
    if (type === 'allbrandsUS') {
      midTitle='Heater US All Brand';
    } else if (type === 'alphaheaterUS') {
      midTitle='Heater US Alpha Heater'
    } else if (type === 'blissheater') {
      midTitle='Heater US Bliss Heater'
    } else if (type === 'heatloopUS') {
      midTitle='Heater US Heat Loop'
    } else if (type === 'heatfinitiUS') {
      midTitle='Heater US Heatfiniti'
    } else if (type === 'novaheat') {
      midTitle='Heater US Nova Heat'
    } else if (type === 'onsenheat') {
      midTitle='Heater US Onsen Heat'
    } else if (type === 'pyrexheat') {
      midTitle='Heater US Pyrex Heat'
    } else if (type === 'smartheater') {
      midTitle='Heater US Smart Heater'
    } else if (type === 'solheaterUS') {
      midTitle='Heater US Sol Heater'
    } else if (type === 'vidaheatUS') {
      midTitle='Heater US Vida Heat'
    } else if (type === 'vistaheatUS') {
      midTitle='Heater US Vista Heat'
    } else if (type === 'vitalheat') {
      midTitle='Heater US Vital Heat'
    } else if (type === 'vitalheatpro') {
      midTitle='Heater V2 US Vital Heat Pro'
    } else if (type === 'warmwaveheat') {
      midTitle='Heater V2 US Warm Wave Heat'
    } else
    if (type === 'rivalsmartwatch') {
      midTitle='Rival Smart Watch'
    } else if (type === 'rivalsportsband') {
      midTitle='Rival Sports Band'
    } else if (type === 'vitalfittrack') {
      midTitle='Vital Fit Track'
    } else if (type === 'bioband') {
      midTitle='Bio Band'
    } else if (type === 'buzzbuglantern') {
      midTitle='Buzz Bug Lantern'
    } else if (type === 'ulticharge') {
      midTitle='Ulti Charge'
    } else if (type === 'sleepease') {
      midTitle='Sleep Ease'
    } else if (type === 'fuelsavepro') {
      midTitle='Fuel Save Pro'
    } else if (type === 'biobandv2'){
      midTitle='Bio Band V2'
    } else if (type === 'blackfalcondrone'){
      midTitle='Black Falcon Drone'
    } else if (type === 'buzzblastpro'){
      midTitle='Buzz Blast Pro'
    } else if (type === 'buzzoffzapper'){
      midTitle='Buzz Off Zapper'
    } else if (type === 'bugvolt'){
      midTitle='Bug Volt'
    } else if (type === 'pulsebandpro'){
      midTitle='Pulse Band Pro'
    } else if (type === 'rivalbuds') {
      midTitle='Rival Buds'
    } else if (type === 'tacticalcarlock') {
      midTitle='Tactical Car Lock'
    } else if (type === 'vitalflexcore') {
      midTitle='Vital Flex Core'
    } else if (type === 'autorescue') {
      midTitle='Auto Rescue'
    } else if (type === 'buzzkrush') {
      midTitle='Buzz Krush'
    } else if (type === 'earthtonerbar') {
      midTitle='Earth Toner Bar'
    } else if (type === 'allura') {
      midTitle='Allura'
    } else if (type === 'grayawaybar') {
      midTitle='Gray Away Bar'
    } else if (type === 'breakbolt') {
      midTitle='Break Bolt'
    } else if (type === 'carresq') {
      midTitle='Car ResQ'
    } else if (type === 'galaxyflyball') {
      midTitle='Galaxy Fly Ball'
    } else if (type === 'quantumlight') {
      midTitle='Quantum Light'
    } else if (type === 'apexpencil') {
      midTitle='Apex Pencil'
    } else if (type === 'astroball') {
      midTitle='Astro Ball'
    } else if (type === 'tacticalheadlight') {
      midTitle='Tactical Headlight'
    } else if (type === 'vitaldashcam') {
      midTitle='Vital Dashcam'
    } else if (type === 'proxtremecam') {
      midTitle='Pro Xtreme Cam'
    } else if (type === 'vitalbrushpro') {
      midTitle='Vital Brush Pro'
    } else if (type === 'minipixsnap') {
      midTitle='Mini Pix Snap'
    } else if (type === 'boltzpro') {
      midTitle='BoltzPro'
    } else if (type === 'magickick') {
      midTitle='Magic Kick'
    } else if (type === 'flyingglowdisc') {
      midTitle='Flying Glow Disc'
    } else if (type === 'vervevroomrccar') {
      midTitle='VerveVroom RC Car'
    } else if (type === 'apexpulsetrack') {
      midTitle='Apex Pulse Track'
    } else if (type === 'rotatogrip') {
      midTitle='Rotato Grip'
    } else if (type === 'hydroblisspro') {
      midTitle='Hydro Bliss Pro'
    } else if (type === 'vitaltacflashlights') {
      midTitle='VitalTac Flashlights'
    } else if (type === 'moodozi') {
      midTitle='Moodozi'
    } else if (type === 'soothely') {
      midTitle='Soothely'
    } else if (type === 'tetrabeam') {
      midTitle='TetraBeam'
    } else if (type === 'copperrelief') {
      midTitle='Copper Relief'
    } else if (type === 'copperrelief2') {
      midTitle='Copper Relief 2'
    } else if (type === 'propowersaverevboost'
            || type === 'propowersaverevboostspecial') {
      midTitle='Pro Power Save (Revboost)';
    } else if (type === 'propulseox') {
      midTitle='Pro Pulse Ox'
    } else if (type === 'akemiskin') {
      midTitle='Akemi Skin'
    } else if (type === 'tacticalchainsaw') {
      midTitle='Tactical Chainsaw'
    } else if (type === 'illumigua') {
      midTitle='IllumiGua'
    } else if (type === 'dermamicrotone') {
      midTitle='Derma Micro Tone'
    } else if (type === 'vitarevivecserum') {
      midTitle='VitaRevive C-Serum'
    } else if (type === 'contourglowpro') {
      midTitle='ContourGlowPro'
    } else if (type === 'akemiglowwand') {
      midTitle='Akemi Glow Wand'
    } else if (type === 'akemirevive') {
      midTitle='Akemi Revive'
    } else if (type === 'vitalearbuds') {
      midTitle='Vital Earbuds'
    } else if (type === 'brightstoneguardian') {
      midTitle='Brightstone Guardian'
    } else if (type === 'trekguardsurvivalstick') {
      midTitle='TrekGuard Survival Stick'
    } else if (type === 'breathegreenionizer') {
      midTitle='Breathe Green Ionizer'
    } else if (type === 'breathegreennanosparkle') {
      midTitle='Breathe Green Nano Sparkle'
    } else if (type === 'breathegreennanosparkle2') {
      midTitle='Breathe Green Nano Sparkle (2)'
    } else if (type === '360brite') {
      midTitle='360Brite'
    } else if (type === 'wifiguardcam') {
      midTitle='WifiGuard Cam'
    } else if (type === 'pixielenspro') {
      midTitle='PixieLens Pro'
    } else if (type === 'camtrack') {
      midTitle='CamTrack'
    } else if (type === 'breathguardbuddy') {
      midTitle='Breath Guard Buddy'
    } else if (type === 'pyrobusterpro') {
      midTitle='Pyro Buster Pro'
    } else if (type === 'miniguardcam') {
      midTitle='MiniGuard Cam'
    } else if (type === 'fursweepcollar') {
      midTitle='Fur Sweep Collar'
    } else if (type === 'airclearpro') {
      midTitle='Air Clear Pro'
    } else if (type === 'buzzrepelprolamp') {
      midTitle='Buzz Repel Pro Lamp'
    } else if (type === 'buzzrepelpro') {
      midTitle='Buzz Repel Pro'
    } else if (type === 'soundrevv') {
      midTitle='SoundRevv'
    } else if (type === 'powerblastplus') {
      midTitle='Power Blast Plus'
    } else if (type === 'rivalrepel') {
      midTitle='Rival Repel'
    } else if (type === 'rivalzapper') {
      midTitle='Rival Zapper'
    } else if (type === 'rivaltac') {
      midTitle='Rival Tac'
    } else if (type === 'fuzebugrevboost') {
      midTitle='Fuzebug (VIP)'
    } else if (type === 'buzzbuglanternrevboost') {
      midTitle='Buzz Bug Lantern (VIP)'
    } else if (type === 'buzzkrushrevboost') {
      midTitle='Buzz Krush (VIP)'
    } else if (type === 'mozzshield') {
      midTitle='Mozz Shield'
    } else if (type === 'repelraylamp') {
      midTitle='Repel Ray Lamp'
    } else if (type === 'buzzbashportable') {
      midTitle='BuzzBash Portable'
    } else if (type === 'buzzheatpro') {
      midTitle='Buzz Heat Pro'
    } else if (type === 'repelraypro') {
      midTitle='Repel Ray Pro'
    } else if (type === 'daysightrevboost') {
      midTitle='DaySight'
    } else if (type === 'aquavital') {
      midTitle='Aqua Vital'
    } else if (type === 'vishift') {
      midTitle='Vi-Shift'
    } else if (type === 'spinviewpro') {
      midTitle='SpinView Pro'
    } else if (type === 'dialoptix') {
      midTitle='DialOptix'
    } else if (type === 'sterilairuv') {
      midTitle='SterilAir UV'
    } else if (type === 'buzzblastprorevboost') {
      midTitle='Buzz Blast Pro (VIP)'
    } else if (type === 'skyhawkdrone') {
      midTitle='Sky Hawk Drone'
    } else if (type === 'breathegreenfreshfoam') {
      midTitle='Breathe Green Fresh Foam'
    } else if (type === 'breathegreenrefreshspray') {
      midTitle='Breathe Green Refresh Spray'
    } else if (type === 'apexpulsetrackrevboost') {
      midTitle='Apex Pulse Track (VIP)'
    } else if (type === 'soundrevvrevboost') {
      midTitle='SoundRevv (VIP)'
    } else if (type === 'inductivv_sc') {
      midTitle='Inductivv (VIP)'
    } else if (type === 'bugvolt_sc') {
      midTitle='Bug Volt (VIP)'
    } else if (type === 'vitaltac_sc') {
      midTitle='VitalTac (VIP)'
    } else if (type === 'saniwhite_sc') {
      midTitle='SaniWHITE (VIP)'
    } else if (type === 'orthosparkle_sc') {
      midTitle='OrthoSparkle (VIP)'
    } else if (type === 'grillsync') {
      midTitle='GrillSync'
    } else if (type === '360brite_sc') {
      midTitle='360Brite (VIP)'
    } else if (type === 'swiveldock') {
      midTitle='Swivel Dock'
    } else if (type === 'fuelsavepro_sc') {
      midTitle='FuelSavePro (VIP)'
    } else if (type === 'elitetac_sc') {
      midTitle='EliteTac (VIP)'
    } else if (type === 'pestdefence_sc') {
      midTitle='Pest Defence (VIP)'
    } else if (type === 'remoteracerz') {
      midTitle='Remote Racerz'
    } else if (type === 'byecritter_sc') {
      midTitle='Bye Critter (VIP)'
    } else if (type === 'pestsprotect_sc') {
      midTitle='Pests Protect (VIP)'
    } else if (type === 'vitaldashcam_sc') {
      midTitle='Vital Dashcam (VIP)'
    } else if (type === 'vitalearbuds_sc') {
      midTitle='Vital Earbuds (VIP)'
    } else if (type === 'vitalflexcore_sc') {
      midTitle='Vital Flex Core (VIP)'
    } else if (type === 'copperreliefsocks_sc') {
      midTitle='Copper Relief Socks (VIP)'
    } else if (type === 'breathegreennanosparkle_sc') {
      midTitle='Breathe Green Nano Sparkle (VIP)'
    } else if (type === 'rotatogrip_sc') {
      midTitle='Rotato Grip (VIP)'
    } else if (type === 'proxtremecam_sc') {
      midTitle='Pro Xtreme Cam (VIP)'
    } else if (type === 'rivalsmartwatch_sc') {
      midTitle='Rival Smart Watch (VIP)'
    } else if (type === 'extendtecc_sc') {
      midTitle='Extendtecc (VIP)'
    } else if (type === 'ionpure_sc') {
      midTitle='Ion Pure (VIP)'
    } else if (type === 'propowersave_sc') {
      midTitle='Pro Power Save (VIP)'
    } else if (type === 'buzzrepelprolamp_sc') {
      midTitle='Buzz Repel Pro Lamp (VIP)'
    } else if (type === 'vitalfittrack_sc') {
      midTitle='Vital Fit Track (VIP)'
    } else if (type === 'tetrabeam_sc') {
      midTitle='TetraBeam (VIP)'
    } else if (type === 'miniguardcam_sc') {
      midTitle='MiniGuard Cam (VIP)'
    } else if (type === 'buzzbashportable_sc') {
      midTitle='BuzzBash Portable (VIP)'
    } else if (type === 'fursweepcollar_sc') {
      midTitle='Fur Sweep Collar (VIP)'
    } else if (type === 'rivalsportsband_sc') {
      midTitle='Rival Sports Band (VIP)'
    } else if (type === 'boltzpro_sc') {
      midTitle='BoltzPro (VIP)'
    } else if (type === 'camtrac_sc') {
      midTitle='CamTrac (VIP)'
    } else if (type === 'bioband_sc') {
      midTitle='Bio Band (VIP)'
    } else if (type === 'pulsebandpro_sc') {
      midTitle='Pulse Band Pro (VIP)'
    } else if (type === 'orthopik_sc') {
      midTitle='Orthopik (VIP)'
    } else if (type === 'ulticharge_sc') {
      midTitle='Ulti-Charge (VIP)'
    } else if (type === 'novimaxx_sc') {
      midTitle='NoviMaxx (VIP)'
    } else if (type === 'moodozi_sc') {
      midTitle='Moodozi (VIP)'
    } else if (type === 'outsmart_sc') {
      midTitle='Outsmart (VIP)'
    } else if (type === 'blackfalcondrone_sc') {
      midTitle='BlackFalconDrone (VIP)'
    } else if (type === 'kizuspineneck_sc') {
      midTitle='Kizu Spine Neck (VIP)'
    } else if (type === 'cleanjett_sc') {
      midTitle='CleanJett (VIP)'
    } else if (type === 'sanipik_sc') {
      midTitle='SaniPik (VIP)'
    } else if (type === 'dentipik_sc') {
      midTitle='DentiPik (VIP)'
    } else if (type === 'suresleep') {
      midTitle='Sure Sleep'
    } else if (type === '') {
      midTitle=''
    } else if (type === '') {
      midTitle=''
    } else if (type === '') {
      midTitle=''
    } else if (type === '') {
      midTitle=''
    }
    
     /************* Advanced Filter ***********/
   const [group,setgroup]=useState('');

   const [groupP,setgroupP]=useState('');

   const [groupT,setgroupT]=useState('');

  //  const [open, setOpen] = React.useState(false);
  //  const handleOpen = () => setOpen(true);
  //  const handleClose = () => setOpen(false);

   const selectInputRef = useRef();
   const selectInputRefInputFilter=useRef();
   const [filterLabel,setFilterLabel]=useState([])
   const [filterValue,setFilterValue]=useState('')
   const [filterArray,setFilterArray]=useState([]);

   const [filterValueT,setFilterValueT]=useState('')
   const [filterArrayT,setFilterArrayT]=useState([]);

   const [filterValueP,setFilterValueP]=useState('')
   const [filterArrayP,setFilterArrayP]=useState([]);

   const [filterValuePredefined,setFilterValuePredefined]=useState('');
   const [filterValueVariation,setFilterValueVariation]=useState('');
   const [filterArrayVariation,setFilterArrayVariation]=useState([]);

   const [selectLabelHeader,setSelectLabelHeader]=useState([]);
   const [selectLabelHeaderP,setSelectLabelHeaderP]=useState([]);
   const [selectLabelHeaderPredefined,setSelectLabelHeaderPredefined]=useState([]);
   const [selectLabelHeaderVariation,setSelectLabelHeaderVariation]=useState([]);


 const loadFilterLabel=(inputValue)=>
 {
   let tempCategory=selectLabelHeader;
   return new Promise((resolve) => {
     resolve(tempCategory.filter((i) =>
           i.label.toLowerCase().includes(inputValue.toLowerCase())
      ))
   });
 }
 const loadFilterLabelP=(inputValue)=>
 {
   let tempCategory=selectLabelHeaderP;
   return new Promise((resolve) => {
     resolve(tempCategory.filter((i) =>
           i.label.toLowerCase().includes(inputValue.toLowerCase())
      ))
   });
 }

 const loadFilterLabelPredefined=(inputValue)=>
 {
   let tempCategory=selectLabelHeaderPredefined;
   return new Promise((resolve) => {
     resolve(tempCategory.filter((i) =>
           i.label.toLowerCase().includes(inputValue.toLowerCase())
      ))
  });
 }

 const loadFilterLabelVariation=(inputValue)=>
 {
   let tempCategory=selectLabelHeaderVariation;
   return new Promise((resolve) => {
     resolve(tempCategory.filter((i) =>
           i.label.toLowerCase().includes(inputValue.toLowerCase())
      ))
  });
 }

 const handleChangeFilterP=(e)=>{
   if(e.target.value!=undefined){
     setFilterValueP(e.target.value);
   }
 }

const handleChangeFilterPredefined=(target)=>{
  if(target!=undefined){    
    setFilterValuePredefined(target.value);
  }
}

const handleChangeFilterVariation=(target)=>{
  if(target!=undefined){    
    setFilterValueVariation(target.value);
  }
}

 const handleChangeFilterT=(e)=>{
   if(e.target.value!=undefined){
     setFilterValueT(e.target.value);
   }
 }


 const addFilterT=()=>{
   if(groupT!='' && filterValueT!=''){
     let tempObj={field:groupT,value:filterValueT};  
       filterArrayT.push(tempObj);
       setFilterArrayT(filterArrayT);
       setFilterValueT('')
   }
 }

 const addFilterP=()=>{
   if(groupP!='' && filterValueP!=''){
     let tempObj={field:groupP,value:filterValueP};  
       filterArrayP.push(tempObj);
       setFilterArrayP(filterArrayP);
       setFilterValueP('')
   }
 }

const addFilterPredefined=()=>{
  if(filterValuePredefined!=''){
    filterValuePredefined.split('|').forEach(i => {
      const [field_with_group, value] = i.split('=');
      const [group, field] = field_with_group.split('.');
      let arr, setArr;
      if (group === 'T') {        
        arr = filterArrayT;
        setArr = setFilterArrayT;
      } else if (group === 'P') {
        arr = filterArrayP;
        setArr = setFilterArrayP;
      }
      if (arr) {
        const found = arr.find(i => i.field === field);
        if (found) {
          found.value = value;
        } else {
          arr.push({field, value});
        }
        setArr(arr);
      }
    });
    setFilterValuePredefined('')
  }
}

const addFilterVariation=()=>{
  if(filterValueVariation !== '') {
    if (filterArrayVariation) {
      const found = filterArrayVariation.find(i => i.field === 'variation');
      if (found) {
        found.value = filterValueVariation;
      } else {
        filterArrayVariation.push({field: 'variation', value: filterValueVariation});
      }
      setFilterArrayVariation(filterArrayVariation);
    }
    setFilterValueVariation('');
  }
}

const deleteAdvancedFilterPFn = (item,index) =>{
  const arr = filterArrayP.filter((item,j) => j!=index);
  console.log(arr)
  setFilterArrayP(arr);
 }

 const deleteAdvancedFilterTFn = (item,index) =>{
  const arr = filterArrayT.filter((item,j) => j!=index);
  console.log(arr)
  setFilterArrayT(arr);
 }

const deleteAdvancedFilterVariationFn = (item,index) =>{
  const arr = filterArrayVariation.filter((item,j) => j!=index);
  console.log(arr)
  setFilterArrayVariation(arr);
 }

const handleChangeT=( target )=> {
 if(target!=undefined){
   setgroupT(target.value);
 }
}

const handleChangeP=( target )=> {
 if(target!=undefined){
   setgroupP(target.value);
 }
}
    
    
    
                    

    

    

    

    












    const reportName=`${midTitle} Take Report`

    const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    const [endDate, setEndDate] = useState(new Date(Date.now()).setHours(23,59,0,0));
    const [selectedrowList,setSelectedRowList]=useState([]);
    const handleSignOut = () => {
        window.localStorage.setItem('isLogin',false);
        history.push('/');
      }

      const setRowBackground = (selectedRow)=>{
        if(inArray(selectedRow.tableData.id,selectedrowList)==false){ 
        setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
        setSelectedRow(selectedRow.tableData.id)
        console.log(selectedrowList)
        }else{    
          setSelectedRow(500000)
          setSelectedRowList([])
        }
      }
  
   
    if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
      history.push('/');
    }

    checkUserTypeFn(history);

    function checkUserTypeFn(history){
      const userdata=JSON.parse(localStorage.getItem('userdata'));
      const usertype=userdata.type;
      console.log('in check usertype fn');
      console.log(usertype)

      if (!checkAccess(FEATURES.take_rate_report)) {
        history.push('/');
      }

      if (!checkTakeRateOfferAccess(type)) {
        history.push('/');
      }
    }
  
    const [reportData,setReportData]=useState([])
    const [loader,setLoader]=useState(false)

    const [consumptionData,setConsumptionData]=useState([])

    const [message, setMessage] = useState('')
    const data = [['attribute', 'attribute2'], ['value1', 'value2']];
    const [successMsg,setSuccessMsg]=useState('')
    useEffect(() => {
      //fetchApi();
      setSelectLabelHeader(objAdvancedFilter.getFilterColumns('transactions'))
      setSelectLabelHeaderP(objAdvancedFilter.getFilterColumns('products'))
      setSelectLabelHeaderPredefined(objAdvancedFilter.getFilterColumns('predefined'));
      setSelectLabelHeaderVariation(
        objAdvancedFilter.getFilterColumns('variations').filter(i => i.offer === type)
      );
      return () => {
        console.log('un subscribe')
        ResetFilter();
        setSummary([])
        setShowSummaryDiv(false)
      }
  
      
  
    }, [midTitle])
    
    const ResetFilter = () => {
      setMessage('')
      setEndDate(new Date(Date.now()))
      setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
      setReportData([]);
      setConsumptionData([]);
    }
   
  const fetchApi = () =>{
    let filterStringP='';
    filterArrayP.forEach((i,j)=>{
      filterStringP+=`P.${i.field}=${i.value}*`
    })

    let filterStringT='';
    filterArrayT.forEach((i,j)=>{
      filterStringT+=`T.${i.field}=${i.value}*`
    })

    let filterStringV='';
    filterArrayVariation.forEach((i,j)=>{
      filterStringV+=`${i.field}=${i.value}*`
    });

    if(startDate==null){
      setMessage('Date must not be blank')
      return false;
    }else{
      setMessage('')
    }
    setLoader(true)
    axiosIntance.get(baseUrl+`/reports/takerate/${type}?startdate=`+moment(startDate).format('YYYY-MM-DD HH:mm:ss')+"&enddate="+moment(endDate).format('YYYY-MM-DD HH:mm:ss')+"&filterStringP="+filterStringP+"&filterStringT="+filterStringT+"&filterStringV="+filterStringV, {}).then(response => {
        if (response.data.result.length > 0) {     
          getSummary(response.data.result)
          response.data.result.forEach((i,j)=>{
            i.revenue = (i.revenue === '-') ? '' : "$" + formatNumberWithToFixed(i.revenue);
          });
          setReportData(response.data.result);
          setConsumptionData(calcConsumptionData(response.data.result));
          setLoader(false)
        } else {
          setLoader(false)
          setReportData([]);
          setConsumptionData([]);
          setShowSummaryDiv(false)
        }
  
      }).catch(error => {
        setLoader(false)
        setMessage('Something went wrong');
      });
  }

  const fetchApiDownload = async() =>{
    //downloadFile();
    let filterStringP='';
    filterArrayP.forEach((i,j)=>{
      filterStringP+=`P.${i.field}=${i.value}*`
    })

    let filterStringT='';
    filterArrayT.forEach((i,j)=>{
      filterStringT+=`T.${i.field}=${i.value}*`
    })

    let filterStringV='';
    filterArrayVariation.forEach((i,j)=>{
      filterStringV+=`${i.field}=${i.value}*`
    });

    const token = window.localStorage.getItem('token');
    window.location.href=baseUrl+`/reports/takerate/${type}/download?startdate=`+moment(startDate).format('YYYY-MM-DD HH:mm:ss')+"&enddate="+moment(endDate).format('YYYY-MM-DD HH:mm:ss')+"&filterStringP="+filterStringP+"&filterStringT="+filterStringT+"&filterStringV="+filterStringV+"&token="+token;
  }

  function calcConsumptionData(data) {
    if (data) {
      try {
        const FE_TYPES = ['front', 'check', 'bundle', 'alone'];
        const REWARD_PRIME_SKU = 'REWARD';
        let fe_total = 0;
        
        const consumption = data.reduce((grouped, item) => {
          if (item.type && item.num_of_orders &&
              item.number_of_units && item.prime_sku && item.prime_sku !== REWARD_PRIME_SKU) {

            const type_lower = item.type.toLowerCase();
            const is_fe = (FE_TYPES.findIndex(i => type_lower.includes(i)) >= 0);
            fe_total += (is_fe ? Number(item.num_of_orders) : 0);

            if (!grouped[item.prime_sku]) {
              grouped[item.prime_sku] = {
                prime_sku: item.prime_sku,
                prime_product_name: item.prime_product_name,
                consumption_total: Number(item.num_of_orders) * Number(item.number_of_units)
              }
            } else {
              grouped[item.prime_sku].consumption_total += Number(item.num_of_orders) * Number(item.number_of_units);
            }
          }
  
          return grouped;
        }, {});

        console.log(consumption);

        return Object.values(consumption)
          // .sort((a, b) => b.consumption_total - a.consumption_total)
          .map(i => {
            // i.consumption_per_fe = (fe_total 
            //   ? Math.round(100 * i.consumption_total / fe_total) / 100
            //   : '-');
            i.consumption_per_fe = (fe_total 
              ? Number(i.consumption_total / fe_total).toFixed(2)
              : '-');
            return i;
          });

      } catch (error) {
        console.error(error);
      }
    }
    return [];
  }

  const getSummary=(result)=>{
    let unique = [...new Set(result.map(item => item.type))]; // [ 'A', 'B']
    let summary=[];

    let temptotalfrontend=getPercentValue(result,'Frontend');
    if(midTitle=='Vital Flex Core'){
      temptotalfrontend=getPercentValue(result,'Stand Alone')+getPercentValue(result,'Bundle 1')+getPercentValue(result,'Bundle 2');
    }
    let tempTotalRevenue=getRevenueSumValue(result);
    let tempAOV=roundToTwo(tempTotalRevenue/temptotalfrontend);
    console.log('tempAOV='+tempAOV)
    console.log('tempTotalRevenue==='+tempTotalRevenue)
    summary.push({
      type:'Frontend',
      sum:temptotalfrontend,
      revenueSum:tempTotalRevenue,
      aov:tempAOV
    });
    
    //getPercentValue(result,'Frontend');
    unique.forEach((type)=>{
      let tempObj={};
      
      if(type!='Frontend' && type.toLowerCase()!='stand alone' && type.toLowerCase()!='bundle 1' && type.toLowerCase()!='bundle 2'){
        let tempsum=getPercentValue(result,type);
        let temprev=getRevenueValue(result,type);
        console.log('temprev=='+temprev)
        //temprev=tempsum*
        tempObj.type=type;
        tempObj.sum=tempsum
        tempObj.revenueSum=temprev
       
       
        if(summary[0].sum!=0){
          tempObj.percent=roundToTwo(tempObj.sum*100/summary[0].sum)+"%";
        }else{
          tempObj.percent="0"+"%";
        }
        
        if (tempObj.revenueSum !== '-') {
          tempObj.revenuetempPercent=temprev/summary[0].revenueSum
          if(summary[0].revenueSum!=0){
            tempObj.revenuePercent=roundToTwo(temprev*100/summary[0].revenueSum)+"%";
          }else{
            tempObj.revenuePercent="0"+"%";
          }
          
          if(temprev!=0){
            //tempObj.aov=roundToTwo(temprev/tempsum);
            tempObj.aov=roundToTwo(tempObj.revenuetempPercent*tempAOV)
          }
          else
            tempObj.aov=0;
        } else {
          tempObj.revenuePercent = '-';
          tempObj.aov = '-';
        }
        summary.push(tempObj);
      }
    })
    summary[0].revenueSum=formatNumberWithToFixed(summary[0].revenueSum);
    setSummary(summary)
    summary.length>0?setShowSummaryDiv(true):setShowSummaryDiv(false)

    console.log('========')
    console.log(summary)
    
  }

  function getPercentValue(result,type,all){
    console.log(all)
    let sum=0;
    result.forEach((i)=>{
      if(type === i.type){
        sum+=parseInt(i.num_of_orders);
      }
    })
    return sum;
  }
  
  function getRevenueValue(result,type,all){
    // console.log('all')
    // console.log(all)
    // console.log('end')

    let filtered = result.filter(i =>i.type === type && i.revenue !== '-');

    if (filtered.length === 0) {
      return '-';
    }

    let revenue = 0;
    filtered.forEach(i => {
      revenue += parseFloat(i.revenue);
    });

    return revenue;
  }

  function getRevenueSumValue(result){

    let revenue=0;
    result.filter(i => i.revenue !== '-').forEach((i)=>{
        revenue+=parseFloat(i.revenue);
    })
    return revenue;
  }

  function removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }
   
   
    return (
  
      <div id="wrapper" className>
        <Sidebar />
        <Header handleSignOut={handleSignOut} />



  <div></div> 
  <div></div>
  <div></div> 
  <div></div>
     
      <div className='errorMsg'>{message}</div>
      <div className='successMsg viewScreen'>{successMsg}</div>
  
  
  
  
    
  
  
<section id="content-wrapper">
<div classname="advancedFilterSection">
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
     <Box sx={style_advanced}>


<label>Transaction Header</label>
<label className='filterValueStyle'>Filter Values</label> 
<div class="input-bar">

<div className="input-bar-item width100">

<AsyncSelect
ref={selectInputRef}
components={animatedComponents}
onChange={e => handleChangeT(e)} 
  cacheOptions
  defaultOptions
  maxMenuHeight={250} 
  className="widthSelectInput"
  classNamePrefix="select"
    styles={colourStyles}
  getOptionLabel={(e) => e.label}
  getOptionValue={(e) => e.value}
  loadOptions={loadFilterLabel}        
/>
</div>

<>

&nbsp;&nbsp;&nbsp;
<div className="input-bar-item width100">
  <input type='text'
     ref={selectInputRefInputFilter}
     className='width140x filterValue'
     placeholder="Value"
     onChange={e => handleChangeFilterT(e)} 
     />
  <AddIcon style={AddIconClasses} onClick={addFilterT}/>
</div>
</>

 
<div className="input-bar-item width100">
<div className="input-bar-item closeModel closeIconCommon"> 
<CloseIcon className='closeIcon' onClick={handleClose}/>
</div>
</div>

</div>

<label>Products Header</label>
<label className='filterValueStyle'>Filter Values</label> 
<div class="input-bar">

<div className="input-bar-item width100">

<AsyncSelect
ref={selectInputRef}
components={animatedComponents}
onChange={e => handleChangeP(e)} 
  cacheOptions
  defaultOptions
  maxMenuHeight={250} 
  className="widthSelectInput"
  classNamePrefix="select"
    styles={colourStyles}
  getOptionLabel={(e) => e.label}
  getOptionValue={(e) => e.value}
  loadOptions={loadFilterLabelP}        
/>
</div>

<>

&nbsp;&nbsp;&nbsp;
<div className="input-bar-item width100">
  <input type='text'
     ref={selectInputRefInputFilter}
     className='width140x filterValue'
     placeholder="Value"
     onChange={e => handleChangeFilterP(e)} 
     />
  <AddIcon style={AddIconClasses} onClick={addFilterP}/>
</div>
</>

</div>

{checkAccess(FEATURES.predefined_filters) && <>

<label>Predefined Filters</label>
<div class="input-bar">

<div className="input-bar-item">

<AsyncSelect
ref={selectInputRef}
components={animatedComponents}
onChange={e => handleChangeFilterPredefined(e)} 
  cacheOptions
  defaultOptions
  maxMenuHeight={250} 
  className="widthSelectInput_Large"
  classNamePrefix="select"
    styles={colourStyles}
  getOptionLabel={(e) => e.label}
  getOptionValue={(e) => e.value}
  loadOptions={loadFilterLabelPredefined}        
/>
  <AddIcon style={{...AddIconClasses, marginLeft: "360px"}} onClick={addFilterPredefined}/>
</div>

</div>
</>}

<label>Variation</label>
<div class="input-bar">
<div className="input-bar-item">
<AsyncSelect
ref={selectInputRef}
components={animatedComponents}
onChange={e => handleChangeFilterVariation(e)} 
  cacheOptions
  defaultOptions
  maxMenuHeight={250} 
  className="widthSelectInput_Large"
  classNamePrefix="select"
    styles={colourStyles}
  getOptionLabel={(e) => e.label}
  getOptionValue={(e) => e.value}
  loadOptions={loadFilterLabelVariation}        
/>
  <AddIcon style={{...AddIconClasses, marginLeft: "360px"}} onClick={addFilterVariation}/>
</div>
</div>

<div className="input-bar-item width100">
<div className="FilterSection">

    {filterArrayT.map((item, index) => (
      <>
        <span className='filterCategory' id={index}>
        <span className="filterSpan">{item.field} = {item.value}</span>
        <CloseIcon onClick={(event) => deleteAdvancedFilterTFn(item,index)} className='closeIcon'/>
        </span>
        <span className="whitespaceSpan">{ '            ' }</span>
        </>
    ))}

{filterArrayP.map((item, index) => (
      <>
        <span className='filterCategory' id={index}>
        <span className="filterSpan">{item.field} = {item.value}</span>
        <CloseIcon onClick={(event) => deleteAdvancedFilterPFn(item,index)} className='closeIcon'/>
        </span>
        <span className="whitespaceSpan">{ '            ' }</span>
        </>
    ))}

    {filterArrayVariation.map((item, index) => (
      <>
        <span className='filterCategory' id={index}>
        <span className="filterSpan">{item.field} = {item.value}</span>
        <CloseIcon onClick={(event) => deleteAdvancedFilterVariationFn(item,index)} className='closeIcon'/>
        </span>
        <span className="whitespaceSpan">{ '            ' }</span>
        </>
    ))}

</div>

</div>




     </Box>
     </Modal>
</div>

{/* <Modal
  open={open}
  onClose={handleClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
<Box sx={style}>
<div className="closeIconCSSTakeRate"> 
<CloseIcon className='closeIcon' onClick={handleClose}/>
</div>

</Box>
</Modal> */}

    <label>Start Date</label>
    <label className='endDateStyle'>End Date</label>
    <div className="input-bar">
    <div className="input-bar-item width100">
    
    <DatePicker
      dateFormat="yyyy-MM-dd HH:mm"
      selected={startDate}
      className='width140x'
      onChange={(date) => setStartDate(date)}
      placeholder='Start Date'

      showTimeSelect
      timeFormat="p"
      timeIntervals={15}
      />

    </div>
    
    &nbsp;&nbsp;&nbsp;
 
    <div className="input-bar-item width100">
    
    <DatePicker
      dateFormat="yyyy-MM-dd HH:mm"
      selected={endDate}
      className='width140x'
      onChange={(date) => setEndDate(date)}
      placeholder='End Date'

      showTimeSelect
      timeFormat="p"
      timeIntervals={15}

      />
      
    </div>
    &nbsp;&nbsp;&nbsp;

    <div className="input-bar-item">
    <button type="button"  onClick={handleOpen}  className="btn btn-primary">Advanced Filter</button>
   
    </div>

    <div className="input-bar-item">
    <button type="button"  onClick={fetchApi} className="btn btn-primary">Run Report</button>
   
    </div>
    <div className='input-bar-item'>
    <button type="button"  onClick={ResetFilter} className="btn btn-primary">Reset</button>
    </div>

    

    {/* <div className='downloadReportBtn'>
        {
          
          reportData.length>0 ? <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>:''
         
        }
       
      </div> */}

      <div className='downloadReportBtn'>
        {
          
          <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>
         
        }
       
      </div>
     
      

     
  </div>
  {/* {summary.length>0 &&
  <div className='summaryIconDiv'>
    <SummarizeIcon className='summaryIcon' onClick={handleOpen}/>
   </div>
} */}

<div className="FilterSection">

    {filterArrayT.map((item, index) => (
      <>
        <span className='filterCategory' id={index}>
        <span className="filterSpan">{item.field} = {item.value}</span>
        <CloseIcon onClick={(event) => deleteAdvancedFilterTFn(item,index)} className='closeIcon'/>
        </span>
        <span className="whitespaceSpan">{ '            ' }</span>
        </>
    ))}

{filterArrayP.map((item, index) => (
      <>
        <span className='filterCategory' id={index}>
        <span className="filterSpan">{item.field} = {item.value}</span>
        <CloseIcon onClick={(event) => deleteAdvancedFilterPFn(item,index)} className='closeIcon'/>
        </span>
        <span className="whitespaceSpan">{ '            ' }</span>
        </>
    ))}

    {filterArrayVariation.map((item, index) => (
      <>
        <span className='filterCategory' id={index}>
        <span className="filterSpan">{item.field} = {item.value}</span>
        <CloseIcon onClick={(event) => deleteAdvancedFilterVariationFn(item,index)} className='closeIcon'/>
        </span>
        <span className="whitespaceSpan">{ '            ' }</span>
        </>
    ))}

</div>

{loader ?
  <div className='loaderDiv'>
    <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" /></div> :

  <>
    <MaterialTable style={{ maxWidth: '56%' }}
      // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}

      onRowClick={((evt, selectedRow) =>
        setRowBackground(selectedRow)
      )}
      columns={[
        {
          title: "Order.Type", field: "type",
          cellStyle: (e, rowdata) => {
            if (rowdata.last == 1) {
              return { fontWeight: 'bold' }
            }
          }
        },
        {
          title: "Product.ID", field: "product_id",
          cellStyle: (e, rowdata) => {
            if (rowdata.last == 1) {
              return { fontWeight: 'bold' }
            }
          }
        }, {
          title: "Product.Name", field: "product_name",
          cellStyle: (e, rowdata) => {
            if (rowdata.last == 1) {
              return { fontWeight: 'bold' }
            }
          }
        },
        {
          title: "Total.Revenue", field: "revenue",


          cellStyle: (e, rowdata) => {
            if (rowdata.last == 1) {
              return { fontWeight: 'bold' }
            }
          }
        },
        {
          title: "Number.of.Orders", field: "num_of_orders",
          cellStyle: (e, rowdata) => {
            if (rowdata.last == 1) {
              return { fontWeight: 'bold' }
            }
          }
        }
      ]}
      data={
        reportData
      }
      title={reportName}
      options={{
        actionsColumnIndex: -1,
        addRowPosition: "first",
        pageSize: 10,
        loadingType: 'linear',
        paging: false,
        exportButton: true,
        maxBodyHeight: '500px',
        headerStyle: { position: 'sticky', top: 0, fontSize: '17px', fontWeight: 'bold' },
        rowStyle: rowData => ({
          backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
        })
      }}

    />
    <br/>

    {showSummaryDiv &&
    <MaterialTable style={{ maxWidth: '56%' }}
        columns={[{
            title: "SKU", field: "prime_sku"
          }, {
            title: "Product", field: "prime_product_name"
          }, {
            title: "Total", field: "consumption_total"
          }, {
            title: "Per FE", field: "consumption_per_fe"            
          }
        ]}
        data={consumptionData}
        title="Consumption"
        options={{
          actionsColumnIndex: -1,
          addRowPosition: "first",
          pageSize: 100,
          loadingType: 'linear',
          paging: false,
          exportButton: true,
          maxBodyHeight: '300px',
          headerStyle: { position: 'sticky', top: 0, fontSize: '14px', fontWeight: 'bold' }
        }}

    />
    }

    <div>
      {showSummaryDiv &&
        <div style={style} className="parent">
          {summary.length > 0 &&
            <>
              <div className='column column1'>
                <span><b>Total Frontends: {summary[0]?.sum}</b></span>
                <br></br>
                {summary.map((item, index) => (
                  <div>
                    <span><b>{item?.type != 'Frontend' ? item.type + " : " + item?.percent : ""}</b></span>
                    <br />
                    <br />
                  </div>
                ))
                }
              </div>

              <div className='column column2'>
                <span><b>Total Revenue: ${summary[0]?.revenueSum}</b></span>
                <br></br>
                {summary.filter(i => i.revenueSum !== '-').map((item, index) => (
                  <div>
                    <span><b>{item?.type != 'Frontend' ? item.type + " : " + item?.revenuePercent : ""}</b></span>
                    <br />
                    <br />
                  </div>
                ))
                }
              </div>

              <div className='column column3'>
                <span><b>AOV: ${!isNaN(summary[0]?.aov) ? summary[0]?.aov : 0}</b></span>
                <br></br>
                {summary.filter(i => i.aov !== '-').map((item, index) => (
                  <div>
                    <span><b>{item?.type != 'Frontend' ? item.type + " : $" + item?.aov : ""}</b></span>
                    <br />
                    <br />
                  </div>
                ))
                }
              </div>
            </>
          }

        </div>
      }



    </div>
  </>


}
        </section>
       
      </div>

    )
}



function roundToTwo(num) {    
  return +(Math.round(num + "e+2")  + "e-2");
}

export default TakeRate
